import React from "react";
import { BsCart } from "react-icons/bs";
import { TiLeaf } from "react-icons/ti";
import { MdOutlineWavingHand } from "react-icons/md";
import { FaSackDollar } from "react-icons/fa6";

const Dashboard = () => {
  return (
    <div className="page-content">
      {/* Start Container Fluid */}
      <div className="container-fluid">
        {/* ========== Page Title Start ========== */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Dashboard</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript: void(0);">Venton</a>
                </li>
                <li className="breadcrumb-item active">Dashboard</li>
              </ol>
            </div>
          </div>
        </div>
        {/* ========== Page Title End ========== */}
        {/* Start here.... */}
        <div className="row">
          <div className="col-xxl-12">
              <div className="card-header d-flex align-items-center justify-content-end gap-2 mb-2">
                
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-light"
                  >
                    ALL
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-light"
                  >
                    Daily
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-light"
                  >
                    Weekly
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-light active"
                  >
                    Monthly
                  </button>
                </div>
            <div className="row">
              <div className="col-md-4">
                <div className="card overflow-hidden">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-6">
                        <div className="avatar-md bg-primary bg-opacity-10 rounded-circle">
                          <BsCart className="avatar-title fs-32 text-primary" />
                        </div>
                      </div>

                      <div className="col-6 text-end">
                        <p className="text-muted mb-0 text-truncate">
                          Total Orders
                        </p>
                        <h3 className="text-dark mt-1 mb-0">15,432</h3>
                      </div>
                    </div>

                    <div dir="ltr" className="mt-4">
                      <div id="orders-chart" className="apex-charts" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="card overflow-hidden">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-6">
                        <div className="avatar-md bg-success bg-opacity-10 rounded-circle">
                          <TiLeaf className="avatar-title fs-32 text-success" />
                        </div>
                      </div>

                      <div className="col-6 text-end">
                        <p className="text-muted mb-0 text-truncate">
                          Total Sales Amount
                        </p>
                        <h3 className="text-dark mt-1 mb-0">12,983</h3>
                      </div>
                    </div>

                    <div dir="ltr" className="mt-4">
                      <div id="new-leads-chart" className="apex-charts" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="card overflow-hidden">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-6">
                        <div className="avatar-md bg-success bg-opacity-10 rounded-circle">
                          <MdOutlineWavingHand className="avatar-title fs-32 text-success" />
                        </div>
                      </div>

                      <div className="col-6 text-end">
                        <p className="text-muted mb-0 text-truncate">
                          Customer Online On Store
                        </p>
                        <h3 className="text-dark mt-1 mb-0">1,283</h3>
                      </div>
                    </div>

                    <div dir="ltr" className="mt-4">
                      <div id="deals-chart" className="apex-charts" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="card overflow-hidden">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-6">
                        <div className="avatar-md bg-primary bg-opacity-10 rounded-circle">
                          <FaSackDollar className="avatar-title fs-32 text-primary" />
                        </div>
                      </div>

                      <div className="col-6 text-end">
                        <p className="text-muted mb-0 text-truncate">
                          Number of Sellers Register
                        </p>
                        <h3 className="text-dark mt-1 mb-0">$234.8k</h3>
                      </div>
                    </div>

                    <div dir="ltr" className="mt-4">
                      <div id="booked-revenue-chart" className="apex-charts" />
                    </div>
                  </div>
                </div>
              </div>

                   <div className="col-md-6">
                <div className="card overflow-hidden">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-6">
                        <div className="avatar-md bg-primary bg-opacity-10 rounded-circle">
                          <FaSackDollar className="avatar-title fs-32 text-primary" />
                        </div>
                      </div>

                      <div className="col-6 text-end">
                        <p className="text-muted mb-0 text-truncate">
                          New Product Uploaded
                        </p>
                        <h3 className="text-dark mt-1 mb-0">$234.8k</h3>
                      </div>
                    </div>

                    <div dir="ltr" className="mt-4">
                      <div id="booked-revenue-chart" className="apex-charts" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="col-xxl-7">
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between gap-2">
                <h4 className="card-title">Performance by Country</h4>
                <div>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-light"
                  >
                    ALL
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-light"
                  >
                    1M
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-light"
                  >
                    6M
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-light active"
                  >
                    1Y
                  </button>
                </div>
              </div>
              <div className="card-body pt-1 px-2">
                <div className="row align-items-center">
                  <div className="col-lg-7">
                    <div id="world-map-markers" style={{ height: 250 }}></div>
                  </div>
                  <div className="col-lg-5" dir="ltr">
                    <div className="p-3 pb-2">
                      <div className="d-flex justify-content-between align-items-center">
                        <p className="mb-1">
                          <iconify-icon
                            icon="circle-flags:us"
                            className="fs-16 align-middle me-1"
                          />
                          <span className="align-middle">United States</span>
                        </p>
                      </div>
                      <div className="row align-items-center mb-3">
                        <div className="col">
                          <div className="progress progress-soft progress-sm">
                            <div
                              className="progress-bar bg-secondary"
                              role="progressbar"
                              style={{ width: "82.05%" }}
                              aria-valuenow=""
                              aria-valuemin={0}
                              aria-valuemax={100}
                            />
                          </div>
                        </div>
                        <div className="col-auto">
                          <p className="mb-0 fs-13 fw-semibold">659k</p>
                        </div>
                      </div>
                     
                      <div className="d-flex justify-content-between align-items-center">
                        <p className="mb-1">
                          <iconify-icon
                            icon="circle-flags:ru"
                            className="fs-16 align-middle me-1"
                          />
                          <span className="align-middle">Russia</span>
                        </p>
                      </div>
                      <div className="row align-items-center mb-3">
                        <div className="col">
                          <div className="progress progress-soft progress-sm">
                            <div
                              className="progress-bar bg-info"
                              role="progressbar"
                              style={{ width: "70.5%" }}
                              aria-valuenow=""
                              aria-valuemin={0}
                              aria-valuemax={100}
                            />
                          </div>
                        </div>
                        <div className="col-auto">
                          <p className="mb-0 fs-13 fw-semibold">485k</p>
                        </div>
                      </div>
                     
                      <div className="d-flex justify-content-between align-items-center">
                        <p className="mb-1">
                          <iconify-icon
                            icon="circle-flags:cn"
                            className="fs-16 align-middle me-1"
                          />
                          <span className="align-middle">China</span>
                        </p>
                      </div>
                      <div className="row align-items-center mb-3">
                        <div className="col">
                          <div className="progress progress-soft progress-sm">
                            <div
                              className="progress-bar bg-primary"
                              role="progressbar"
                              style={{ width: "65.8%" }}
                              aria-valuenow=""
                              aria-valuemin={0}
                              aria-valuemax={100}
                            />
                          </div>
                        </div>
                        <div className="col-auto">
                          <p className="mb-0 fs-13 fw-semibold">355k</p>
                        </div>
                      </div>
                     
                      <div className="d-flex justify-content-between align-items-center">
                        <p className="mb-1">
                          <iconify-icon
                            icon="circle-flags:ca"
                            className="fs-16 align-middle me-1"
                          />
                          <span className="align-middle">Canada</span>
                        </p>
                      </div>
                      <div className="row align-items-center">
                        <div className="col">
                          <div className="progress progress-soft progress-sm">
                            <div
                              className="progress-bar bg-success"
                              role="progressbar"
                              style={{ width: "55.8%" }}
                              aria-valuenow=""
                              aria-valuemin={0}
                              aria-valuemax={100}
                            />
                          </div>
                        </div>
                        <div className="col-auto">
                          <p className="mb-0 fs-13 fw-semibold">204k</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>

        {/* <div className="row">
          <div className="col-lg-8">
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between gap-2">
                <h4 className="card-title">Product Performance</h4>
                <div>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-light"
                  >
                    ALL
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-light"
                  >
                    1M
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-light"
                  >
                    6M
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-light active"
                  >
                    1Y
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="row text-center">
                  <div className="col-md-3 col-6">
                    <div className="bg-soft-light">
                      <p className="text-muted pt-3 mb-1">Total Sales</p>
                      <h4 className="pb-3">
                        <span>$50.4k</span>
                      </h4>
                    </div>
                  </div>
                  <div className="col-md-3 col-6">
                    <div className="bg-soft-light">
                      <p className="text-muted pt-3 mb-1">Total Refunds</p>
                      <h4 className="pb-3">
                        <span>$3.2k</span>
                      </h4>
                    </div>
                  </div>
                  <div className="col-md-3 col-6">
                    <div className="bg-soft-light">
                      <p className="text-muted pt-3 mb-1">Total Orders</p>
                      <h4 className="pb-3">
                        <span>1,200</span>
                      </h4>
                    </div>
                  </div>
                  <div className="col-md-3 col-6">
                    <div className="bg-soft-light">
                      <p className="text-muted pt-3 mb-1">Net Profit</p>
                      <h4 className="pb-3">
                        <span>$15.7k</span>
                      </h4>
                    </div>
                  </div>
                </div>
                <div dir="ltr">
                  <div id="dash-performance-chart" className="apex-charts" />
                </div>
              </div>
            </div>
        
          </div>

          <div className="col-lg-4">
            <div className="card card-height-100">
              <div className="card-header d-flex align-items-center justify-content-between gap-2">
                <h4 className="card-title flex-grow-1">Trending Products</h4>
                <a href="#" className="btn btn-sm btn-soft-primary">
                  View All
                </a>
              </div>
              <div className="card-body pt-0 pb-1">
                <div dir="ltr">
                  <div id="basic-heatmap" className="apex-charts" />
                </div>
              </div>
              <div className="table-responsive">
                <table className="table table-hover table-sm table-nowrap table-centered m-0">
                  <thead className="bg-light bg-opacity-50">
                    <tr>
                      <th className="text-muted ps-3 py-1 border-0">
                        Page Path
                      </th>
                      <th className="text-muted py-1 border-0">Page Views</th>
                      <th className="text-muted py-1 border-0">Exit Rate</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="ps-3">
                        <a href="#" className="text-muted">
                          venton/iphone-16.html
                        </a>
                      </td>
                      <td>465 </td>
                      <td>
                        <span className="badge badge-soft-success">4.4%</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="ps-3">
                        <a href="#" className="text-muted">
                          venton/ipad-pro.html
                        </a>
                      </td>
                      <td> 426</td>
                      <td>
                        <span className="badge badge-soft-danger">20.4%</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="ps-3">
                        <a href="#" className="text-muted">
                          venton/imac.html
                        </a>
                      </td>
                      <td>254 </td>
                      <td>
                        <span className="badge badge-soft-warning">12.25%</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="ps-3">
                        <a href="#" className="text-muted">
                          venton/macbook-pro.html
                        </a>
                      </td>
                      <td> 3369</td>
                      <td>
                        <span className="badge badge-soft-success">5.2%</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="ps-3">
                        <a href="#" className="text-muted">
                          venton/other.html
                        </a>
                      </td>
                      <td>985 </td>
                      <td>
                        <span className="badge badge-soft-danger">64.2%</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div> */}

        {/* <div className="row">
          <div className="col-lg-4">
            <div className="card">
              <div className="d-flex card-header align-items-center justify-content-between">
                <h4 className="card-title">Conversions</h4>
                <a href="#!" className="btn btn-sm btn-soft-primary">
                  <i className="bx bx-refresh me-1" />
                  Refresh
                </a>
              </div>
              <div className="card-body">
                <div className="alert alert-info mb-0" role="alert">
                  We regret to inform you that our server is currently
                  experiencing technical difficulties.
                </div>
                <div id="conversions" className="apex-charts mt-n2" />
              </div>
            </div>
          </div>
          <div className="col-lg-8">
            <div className="card">
              <div className="d-flex card-header align-items-center justify-content-between">
                <h4 className="card-title">Recent Orders</h4>
                <a href="#!" className="btn btn-sm btn-soft-primary">
                  <i className="bx bx-plus me-1" />
                  Create Order
                </a>
              </div>

              <div className="table-responsive table-centered">
                <table className="table table-hover table-sm mb-0">
                  <thead className="bg-light bg-opacity-50">
                    <tr>
                      <th className="ps-3 border-0">Order ID.</th>
                      <th className="border-0">Date</th>
                      <th className="border-0">Product</th>
                      <th className="border-0">Customer Name</th>
                      <th className="border-0">Phone No.</th>
                      <th className="border-0">Address</th>
                      <th className="border-0">Payment Type</th>
                      <th className="border-0">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="ps-3">
                        <a href="#!">#TZ5625</a>
                      </td>
                      <td>29 April 2024</td>
                      <td>
                        <img
                          src="/images/products/product-1(1).png"
                          alt="product-1(1)"
                          className="img-fluid avatar-sm"
                        />
                      </td>
                      <td>
                        <a href="#!">Anna M. Hines</a>
                      </td>
                      <td>(+1)-555-1564-261</td>
                      <td>Burr Ridge/Illinois</td>
                      <td>Credit Card</td>
                      <td>
                        <i className="bx bxs-circle text-success me-1" />
                        Completed
                      </td>
                    </tr>
                    <tr>
                      <td className="ps-3">
                        <a href="#!">#TZ9652</a>
                      </td>
                      <td>25 April 2024</td>
                      <td>
                        <img
                          src="/images/products/product-4.png"
                          alt="product-4"
                          className="img-fluid avatar-sm"
                        />
                      </td>
                      <td>
                        <a href="#!">Judith H. Fritsche</a>
                      </td>
                      <td>(+57)-305-5579-759</td>
                      <td>SULLIVAN/Kentucky</td>
                      <td>Credit Card</td>
                      <td>
                        <i className="bx bxs-circle text-success me-1" />
                        Completed
                      </td>
                    </tr>
                    <tr>
                      <td className="ps-3">
                        <a href="#!">#TZ5984</a>
                      </td>
                      <td>25 April 2024</td>
                      <td>
                        <img
                          src="/images/products/product-5.png"
                          alt="product-5"
                          className="img-fluid avatar-sm"
                        />
                      </td>
                      <td>
                        <a href="#!">Peter T. Smith</a>
                      </td>
                      <td>(+33)-655-5187-93</td>
                      <td>Yreka/California</td>
                      <td>Pay Pal</td>
                      <td>
                        <i className="bx bxs-circle text-success me-1" />
                        Completed
                      </td>
                    </tr>
                    <tr>
                      <td className="ps-3">
                        <a href="#!">#TZ3625</a>
                      </td>
                      <td>21 April 2024</td>
                      <td>
                        <img
                          src="/images/products/product-6.png"
                          alt="product-6"
                          className="img-fluid avatar-sm"
                        />
                      </td>
                      <td>
                        <a href="#!">Emmanuel J. Delcid</a>
                      </td>
                      <td>(+30)-693-5553-637</td>
                      <td>Atlanta/Georgia</td>
                      <td>Pay Pal</td>
                      <td>
                        <i className="bx bxs-circle text-primary me-1" />
                        Processing
                      </td>
                    </tr>
                    <tr>
                      <td className="ps-3">
                        <a href="#!">#TZ8652</a>
                      </td>
                      <td>18 April 2024</td>
                      <td>
                        <img
                          src="/images/products/product-1(2).png"
                          alt="product-1(2)"
                          className="img-fluid avatar-sm"
                        />
                      </td>
                      <td>
                        <a href="#!">William J. Cook</a>
                      </td>
                      <td>(+91)-855-5446-150</td>
                      <td>Rosenberg/Texas</td>
                      <td>Credit Card</td>
                      <td>
                        <i className="bx bxs-circle text-primary me-1" />
                        Processing
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="card-footer border-top">
                <div className="row align-items-center g-3">
                  <div className="col-sm">
                    <div className="text-muted">
                      Showing
                      <span className="fw-semibold">5</span>
                      of
                      <span className="fw-semibold">90,521</span>
                      orders
                    </div>
                  </div>
                  <div className="col-sm-auto">
                    <ul className="pagination pagination-rounded m-0">
                      <li className="page-item">
                        <a href="#" className="page-link">
                          <i className="bx bx-left-arrow-alt" />
                        </a>
                      </li>
                      <li className="page-item active">
                        <a href="#" className="page-link">
                          1
                        </a>
                      </li>
                      <li className="page-item">
                        <a href="#" className="page-link">
                          2
                        </a>
                      </li>
                      <li className="page-item">
                        <a href="#" className="page-link">
                          3
                        </a>
                      </li>
                      <li className="page-item">
                        <a href="#" className="page-link">
                          <i className="bx bx-right-arrow-alt" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
      {/* End Container Fluid */}
      {/* ========== Footer Start ========== */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />
              <a href="" className="fw-bold footer-text" target="_blank">
                Techzaa
              </a>
            </div>
          </div>
        </div>
      </footer>
      {/* ========== Footer End ========== */}
    </div>
  );
};

export default Dashboard;
